// export const environment = {
//   production: false,
//   appConfigPath: '/assets/config/app.config.json'
// };
export const environment = {
  production: true,
  appConfigPath: '/assets/config/app.config.prod.json'
};
